/**
 * Résout le libellé pilote/voiture d’un slot.
 * En solo, ne jamais réutiliser un cache serveur (meeting/MP précédent) :
 * sinon le HUD affiche des noms fantômes et masque le vrai joueur courant.
 */
export type PlayerDisplayInfo = {
  driverName: string;
  carName: string;
  nationality?: string;
  driverImagePath?: string;
};

export function resolvePlayerDisplayInfo(opts: {
  isMultiplayer: boolean;
  fromServer?: PlayerDisplayInfo | null;
  local?: PlayerDisplayInfo | null;
  playerIndex: number;
}): PlayerDisplayInfo {
  const { isMultiplayer, fromServer, local, playerIndex } = opts;
  if (isMultiplayer && fromServer) {
    return { ...fromServer };
  }
  if (local) {
    return { ...local };
  }
  return { driverName: `Joueur ${playerIndex + 1}`, carName: '—' };
}
